export default [
  [`Размеры`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Плечи`, `41`, `41`, `42`, `45`, `45`],
  [`Грудь`, `43.5`, `45`, `47`, `50`, `52`],
  [`Длина`, `60`, `66`, `67`, `67.5`, `67.5`]
];
